module.exports = __webpack_public_path__ + "img/donnie-pro.04a0c0f7.jpg";